module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "top_view.dea4b183.png";